import { dateDiffMilliseconds, getNow } from './date.js';
export function isSubscriptionExpired({ subscriptionEndDate }) {
    if (!subscriptionEndDate) {
        return true;
    }
    return dateDiffMilliseconds(getNow(), subscriptionEndDate) <= 0;
}
export function isSubscriber(user) {
    return user.roles.includes('subscriber') && !isSubscriptionExpired(user);
}
